import { render, staticRenderFns } from "./SupplementCalendary.vue?vue&type=template&id=48e2b317&scoped=true"
import script from "./SupplementCalendary.vue?vue&type=script&lang=js"
export * from "./SupplementCalendary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2b317",
  null
  
)

export default component.exports